// extracted by mini-css-extract-plugin
export default {"Warning":"AmpWarning_Warning__10HOz","Show":"AmpWarning_Show__FHbp+"};